<template>
    <div>
        <v-form ref="form" v-if="!formSend" lazy-validation>
            <h2>{{ 'cancellation form header' | translation }}</h2>
            <p>
                {{ 'cancellation form hint 1' | translation }}
            </p>
            <v-text-field
                v-model="firstName"
                v-bind:label="'name' | translation"
                data-vv-name="firstName"
                required
                :rules="rules.required"
            ></v-text-field>
            <v-text-field
                v-model="lastName"
                v-bind:label="'surname' | translation"
                data-vv-name="surname"
                :rules="rules.required"
                required
            ></v-text-field>
            <v-text-field
                v-model="orderId"
                v-bind:label="'cancellation form order id' | translation"
                data-vv-name="orderId"
            ></v-text-field>
            <v-text-field
                v-model="email"
                v-bind:label="'email' | translation"
                data-vv-name="email"
                :rules="rules.email"
                required
            ></v-text-field>
            <v-textarea
                v-model="message"
                v-bind:label="'cancellation reason' | translation"
                data-vv-name="message"
                :rules="rules.required"
                required
            ></v-textarea>
            
            <br />
            <h4>{{ 'cancellation form hint mandatory fields' | translation }}</h4>
            <br />
            <v-btn color="primary" id="g-recaptcha" @click="save" :loading="loading" :disabled="loading">
                {{ 'Confirm cancellation' | translation }}
            </v-btn>
        </v-form>

        <v-dialog v-model="displayErrorModal" width="550">
            <v-card>
                <v-card-text>
                    <span>
                        {{ "Das Formular konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Support." | translation }}
                    </span>
                </v-card-text>

                <v-card-actions>
                    <v-btn @click="displayErrorModal = false">{{'Close' | translation}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import gql from 'graphql-tag';

export default {
    name: 'CancellationForm',
    data: () => ({
        firstName: '',
        lastName: '',
        orderId: '',
        email: '',
        message: '',
        CAPTCHA_KEY: '',

        formSend: false,
        loading: false,
        displayErrorModal: false,
    }),
    mounted() {
        this.loadCaptcha(100, 10000, 'https://www.google.com/recaptcha/api.js');
        this.CAPTCHA_KEY = Vue.$config.CAPTCHA_PUBLIC_KEY;

        try {
            window.grecaptcha.ready(function() {
                window.grecaptcha.render('g-recaptcha', {
                    sitekey: Vue.$config.CAPTCHA_PUBLIC_KEY,
                });
            });
        } catch (e) {}
    },
    methods: {
        formValid() {
            return this.$refs.form.validate();
        },
        save() {
            window.grecaptcha
                .execute()
                .then(() => {
                    if (this.formValid()) {
                        this.loading = true;
                        this.sendForm({
                            firstName: this.firstName,
                            lastName: this.lastName,
                            orderId: this.orderId,
                            email: this.email,
                            message: this.message,
                        })
                            .then(() => {
                                this.loading = false;
                                this.$router.push('widerruf-abschluss');
                            })
                            .catch(e => {
                                this.loading = false;
                                this.displayErrorModal = true;
                                console.log(e);
                            });
                    }
                })
                .catch(e => console.log(e, 'ROBOT!'));
        },
        sendForm(cancellation) {
            return Vue.$graphql.mutate({
                mutation: gql`
                    mutation createCancellation($cancellation: CancellationInput!) {
                        createCancellation(cancellation: $cancellation)
                    }
                `,
                variables: {
                    cancellation: cancellation,
                },
            });
        },
        loadCaptcha(callInterval, delay, url) {
            let that = this;
            let r,
                timeSpend,
                i = setInterval(function() {
                    timeSpend += callInterval;
                    r = typeof require === 'function';
                    if (timeSpend >= delay || r) clearInterval(i);
                    if (r) {
                        that.loadCaptchaScript(url)
                            .then(function() {
                                try {
                                    window.grecaptcha.ready(function() {
                                        window.grecaptcha.render('g-recaptcha', {
                                            sitekey: Vue.$config.CAPTCHA_PUBLIC_KEY,
                                        });
                                    });
                                } catch (e) {}
                            })
                            .catch(function(err) {
                                console.error('Something went wrong!', err);
                            });
                    }
                }, callInterval);
        },
        loadCaptchaScript(url) {
            return new Promise(function(resolve, reject) {
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.id = 'captcha-script';
                script.src = url;
                script.onload = resolve;
                script.onerror = reject;
                if (!document.getElementById(script.id)) {
                    document.head.appendChild(script);
                }
            })
                .then(() => {
                    return true;
                })
                .catch(error => console.log(error));
        },
    },
    computed: {
        rules: function() {
            return {
                required: [v => !!v || this.$language.translate('Field is required.')],
                email: [
                    v => !!v || this.$language.translate('Field is required.'),
                    v => /.+@.+/.test(v) || this.$language.translate('E-mail must be valid.'),
                ],
            };
        },
    },
};
</script>

<style scoped></style>
